module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-wrap",
    attrs: {
      "id": "registry"
    }
  }, [(_vm.status == 0) ? _c('div', {
    staticClass: "ac-con"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ac-con-ct"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNum),
      expression: "phoneNum"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phoneNum)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.changeFocus(1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.changeFocus(1)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.accountRegistry($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgcode),
      expression: "imgcode"
    }],
    staticStyle: {
      "width": "160px",
      "float": "left"
    },
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.imgcode)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        _vm.changeFocus(0)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.accountRegistry($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        _vm.changeFocus(0)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ac-verify",
    on: {
      "click": _vm.changeVerify
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.verifyUrl,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('div', {
    staticClass: "ac-btn",
    on: {
      "click": _vm.accountRegistry
    }
  }, [_vm._v("下一步")])])]), _vm._v(" "), _c('div', {
    staticClass: "ac-con-rt"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [(_vm.phoneState.type != '') ? _c('p', {
    staticClass: "ac-con-msg"
  }, [_c('ep-alert', {
    attrs: {
      "type": _vm.phoneState.type
    }
  }, [_vm._v(_vm._s(_vm.phoneState.msg))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [(_vm.imgState.type != '') ? _c('p', {
    staticClass: "ac-con-msg"
  }, [_c('ep-alert', {
    attrs: {
      "type": _vm.imgState.type
    }
  }, [_vm._v(_vm._s(_vm.imgState.msg))])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.status == 1) ? _c('div', {
    staticClass: "ac-con"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ac-con-ct"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [_c('span', [_vm._v(_vm._s(_vm.formatPhone(_vm.phoneNum)))])]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.smscode),
      expression: "smscode"
    }],
    staticStyle: {
      "width": "160px",
      "float": "left"
    },
    attrs: {
      "type": "text",
      "autofocus": "",
      "name": "",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.smscode)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.smsVerify($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.smscode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: ['ac-verify', 'ac-send', {
      'active': _vm.smsStatu
    }],
    on: {
      "click": _vm.isSendSms
    }
  }, [_vm._v(_vm._s(_vm.smsCon))])]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('div', {
    staticClass: "ac-btn",
    on: {
      "click": _vm.smsVerify
    }
  }, [_vm._v("下一步")])])]), _vm._v(" "), _c('div', {
    staticClass: "ac-con-rt"
  }, [_c('div', {
    staticClass: "ac-general"
  }), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [(_vm.smsState.type != '') ? _c('p', {
    staticClass: "ac-con-msg"
  }, [_c('ep-alert', {
    attrs: {
      "type": _vm.smsState.type
    }
  }, [_vm._v(_vm._s(_vm.smsState.msg))])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.status == 2) ? _c('div', {
    staticClass: "ac-con"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ac-con-ct"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pwd),
      expression: "pwd"
    }],
    attrs: {
      "type": "password",
      "autofocus": "",
      "name": "",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.pwd)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setPassword($event)
      },
      "focus": function($event) {
        _vm.pwdStatu = {
          type: '',
          msg: ''
        };
        _vm.confirmStatu = {
          type: '',
          msg: ''
        };
        _vm.pwdState = true
      },
      "blur": function($event) {
        _vm.pwdState = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    attrs: {
      "type": "password",
      "name": "",
      "placeholder": "请再次输入密码"
    },
    domProps: {
      "value": (_vm.confirm)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setPassword($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rgname),
      expression: "rgname"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "输入您的姓名，申报时对审批者可见"
    },
    domProps: {
      "value": (_vm.rgname)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setPassword($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rgname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_c('div', {
    staticClass: "ac-btn",
    on: {
      "click": _vm.setPassword
    }
  }, [_vm._v("完成")])])]), _vm._v(" "), _c('div', {
    staticClass: "ac-con-rt"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [(_vm.pwdShowTip) ? _c('p', {
    staticClass: "message-tip"
  }, [_vm._v("\n          密码长度为8-20个字符，且至少包含1个大写字母，1个小写字母和1个数字\n        ")]) : _vm._e(), _vm._v(" "), (_vm.pwdStatu.type != '') ? _c('p', {
    staticClass: "ac-con-msg"
  }, [_c('ep-alert', {
    attrs: {
      "type": _vm.pwdStatu.type
    }
  }, [_vm._v(_vm._s(_vm.pwdStatu.msg))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [(_vm.confirmStatu.type != '') ? _c('p', {
    staticClass: "ac-con-msg"
  }, [_c('ep-alert', {
    attrs: {
      "type": _vm.confirmStatu.type
    }
  }, [_vm._v(_vm._s(_vm.confirmStatu.msg))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [(_vm.rgnameState.type != '') ? _c('p', {
    staticClass: "ac-con-msg"
  }, [_c('ep-alert', {
    attrs: {
      "type": _vm.rgnameState.type
    }
  }, [_vm._v(_vm._s(_vm.rgnameState.msg))])], 1) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-con-lt"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_vm._v("验证码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-con-lt"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_vm._v("短信验证码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ac-con-lt"
  }, [_c('div', {
    staticClass: "ac-general"
  }, [_vm._v("设置密码")]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('div', {
    staticClass: "ac-general"
  }, [_vm._v("真实姓名")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-570e71bf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Registry.vue
// module id = 1230
// module chunks = 2